// src/pages/Confirm.jsx
import React, { useEffect, useState } from "react";
import "./Confirm.css";
import { useNavigate } from "react-router-dom";
import { account } from "../../appwrite/appwriteConfig";
import LogoDownload from "../../assets/LogoDownload.png";
import LogoDownloadFooter from "../../assets/LogoDownloadFooter.svg";
import backgroundSquareDownload from "../../assets/backgroundSquareDownload.webp";
import navExtIcon from "../../assets/navExtIcon.svg";
import { useAuth } from "../../utils/AuthContext";

export default function Confirm() {
    const navigate = useNavigate();
    const [isVerified, setIsVerified] = useState(false);
    const [error, setError] = useState(null);
    const [dotCount, setDotCount] = useState(1);
    const { sendOnboardingEmail } = useAuth();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const secret = urlParams.get("secret");
        const userId = urlParams.get("userId");
        const alreadyVerified = urlParams.get("verified");

        if (alreadyVerified) {
            setIsVerified(true);
            return; // skip re-verification
        }

        if (!secret || !userId) {
            setError("Invalid verification link");
            return;
        }

        account
            .updateVerification(userId, secret)
            .then(async () => {
                setIsVerified(true);

                // Update URL so refresh won't break
                const newParams = new URLSearchParams(window.location.search);
                newParams.set("verified", "true");
                window.history.replaceState(
                    {},
                    "",
                    `${window.location.pathname}?${newParams.toString()}`
                );

                await sendOnboardingEmail();
            })
            .catch((err) => {
                setError(err.message || "Verification failed");
            });
    }, [sendOnboardingEmail]);

    useEffect(() => {
        if (!isVerified && !error) {
            const interval = setInterval(() => {
                setDotCount((prev) => (prev % 3) + 1);
            }, 400);
            return () => clearInterval(interval);
        }
    }, [isVerified, error]);

    return (
        <>
            <title>Confirm Your Account | Oakmate</title>
            <meta
                name="description"
                content="Finalize your Oakmate account setup by confirming your email."
            />
            <div className="confirmPage">
                <img
                    src={backgroundSquareDownload}
                    alt="Background"
                    className="backgroundSquareDownload"
                />

                {isVerified ? (
                    <div className="download-container">
                        <div className="main-wrapper">
                            <div
                                className="logo-wrapper"
                                onClick={() => navigate("/")}
                            >
                                <img
                                    src={LogoDownload}
                                    alt="Logo"
                                    className="LogoConfirm"
                                />
                            </div>
                            <div className="text-wrapper">
                                <div className="text-title">
                                    You're all set!
                                </div>
                                <div className="text-sub">Email verified.</div>
                            </div>
                            <button
                                className="download-cta"
                                onClick={() => {
                                    window.open(
                                        "https://www.chess.com/home",
                                        "_blank"
                                    );
                                }}
                            >
                                <div className="download-cta-text">
                                    Back to Chess.com
                                </div>
                                <img
                                    src={navExtIcon}
                                    className="download-cta-icon"
                                    alt="Download Icon"
                                />
                            </button>
                        </div>
                    </div>
                ) : error ? (
                    <div className="error-state">
                        <div className="text-title">Verification Failed</div>
                        <div className="text-sub error">{error}</div>
                        <button
                            className="retry-button"
                            onClick={() => navigate("/")}
                        >
                            Back to Home Page
                        </button>
                    </div>
                ) : (
                    <div className="text-sub">
                        Verifying Email
                        <span>{".".repeat(dotCount)}</span>
                    </div>
                )}

                <div className="copyright">
                    Copyright © 2025 Oakmate. All rights reserved
                </div>
                <div className="oakmatebackgroundlogo-wrapper">
                    <img
                        src={LogoDownloadFooter}
                        alt="Logo background"
                        className="LogoDownloadFooter"
                    />
                    <div className="maskdownloadfooter" />
                </div>
            </div>
        </>
    );
}
